<template>
  <div>
  <b-modal v-model="modalShow" id="modalPopover" centered cancel-disabled no-close-on-esc no-close-on-backdrop hide-header-close hide-footer :title="$t('videoSession')">
    <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;"><img width="96px" height="96px" src="/static-appopensalud/img/icons/video-icon.svg"/></div>
    <p style="text-align: center">{{ $t('needValidToken') }}</p>
    <div class="col text-center pt-1">
      <b-input id="token-input" v-model="smallToken" :placeholder="$t('introduce-token')"></b-input>
      <br>
      <b-button variant="primary" align-h="center" @click="goToSession">{{ $t('go-to-session') }}</b-button>
    </div>
  </b-modal>
  </div>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'Start',
  components: {
    BModal,
    BButton
  },
  data () {
    return {
      modalShow: true,
      smallToken: null
    }
  },
  created () {
    this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
  },
  methods: {
    goToSession () {
      window.location = `/${this.$i18n.locale}/${this.smallToken}`
      /* this.$router.push({ name: 'Video', path: this.$i18n.locale + '/' + this.smallToken, params: { token: this.smallToken } }) */
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495e;
}

#token-input {
  margin: 0 auto;
  width: 221px;
}

</style>



// WEBPACK FOOTER //
// src/components/video-launcher/Start.vue